import {createBrowserHistory} from 'history';
// const history = createBrowserHistory();
const history = createBrowserHistory();
export default history;
